import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

import PageBody from 'components/atoms/PageBody'
import PageHeading from 'components/atoms/PageHeading'

import { crudActionsMap } from 'utils/helpers'
import AnnouncementForm from 'components/organisms/forms/AnnouncementForm'


const AnnouncementCrudPage = () => {
  const { t } = useTranslation()
  const params = useParams()
  const id = params?.id
  const action = crudActionsMap[params['*']?.split('/')?.[1]]

  const viewOnly = action === 'view' || action === 'delete' 

  return (
    <>
      <PageHeading title={`${t('common.announcements')} / ${t('common.' + action)}`} />
      <PageBody>
        <AnnouncementForm action={action} id={id} viewOnly={viewOnly} />
      </PageBody>
    </>
  )
}
export default AnnouncementCrudPage
